export default {
  nav: {
    home: "Início",
    categories: "Categorias",
    article: "Guia",
    ctaMain: "Site Principal",
    ctaSpreadsheet: "CSSBuy Spreadsheet",
  },
  hero: {
    eyebrow: "CSSBuy Spreadsheet • Pesquisa • QC • Envio",
    title: "CSSBuy Spreadsheet: Encontre, Compare e Pesquise Produtos com Mais Facilidade",
    description: "Explore um CSSBuy Spreadsheet organizado com guias de produtos, categorias, informações de QC, orientações de envio, warehouse, avaliações e dicas práticas para pesquisar antes de comprar.",
    ctaPrimary: "Explorar CSSBuy Spreadsheet",
    ctaSecondary: "Começar o Guia para Iniciantes",
    trust: "Recurso independente • Conteúdo atualizado • Guias multilíngues • Foco em segurança",
    searchPlaceholder: "Pesquise no CSSBuy Spreadsheet...",
  },
  categories: {
    title: "Explore o CSSBuy Spreadsheet por categoria",
    dropdownLabel: "Selecione uma Categoria",
    shoes: "Tênis",
    hoodies: "Hoodies/Sweaters",
    tshirts: "Camisetas",
    jackets: "Jaquetas",
    pants: "Calças/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear/Underpants",
    jersey: "Jersey",
    accessories: "Acessórios",
    bags: "Bolsas",
    belts: "Cintos",
    perfumes: "Perfumes",
    other: "Outros",
  },
  cta: {
    title: "Pronto para começar sua pesquisa?",
    description: "Use o CSSBuy Spreadsheet como ponto de partida para descobrir categorias, comparar informações e aprender como avaliar produtos, QC, warehouse e envio antes de continuar.",
    button1: "Explorar CSSBuy Spreadsheet",
    button2: "Visitar o Site Principal",
    buttonBuy: "Comprar Agora",
  },
  article: {
    title: "Guia Completo do CSSBuy Spreadsheet",
    description: "Aprenda a usar o CSSBuy Spreadsheet para pesquisa de produtos, navegação por categorias e verificação de qualidade antes de comprar.",
    readMore: "Ler Guia Completo",
  },
  footer: {
    disclaimer: "Este site é um recurso informativo independente e não é o site oficial da CSSBuy.",
    copyright: "© 2026 cssbuybr.fun. Todos os direitos reservados.",
  },
  language: "Idioma",
  articlePage: {
    title: "Guia Completo do CSSBuy Spreadsheet: Pesquise Produtos de Forma Inteligente em 2026",
    metaDescription: "Um guia completo para usar o CSSBuy Spreadsheet na pesquisa de produtos, navegação por categorias e verificação de QC. Recurso independente para 2026.",
    breadcrumb: "Início / Guia",
    published: "Publicado: 15 de janeiro de 2026",
    updated: "Última atualização: 1 de setembro de 2026",
    backToHome: "← Voltar ao Início",
    sections: {
      intro: {
        title: "O que é o CSSBuy Spreadsheet?",
        content: "O CSSBuy Spreadsheet é um recurso estruturado que ajuda os compradores a organizar links de produtos, categorias, preços e notas de pesquisa em um único lugar. Em vez de pesquisar em várias plataformas e salvar links dispersos, você pode usar uma planilha para acompanhar os itens por categoria, comparar opções e verificar detalhes antes de tomar uma decisão de compra. Este guia explica como usar o CSSBuy Spreadsheet de forma eficaz para pesquisa de produtos em 2026.",
      },
      research: {
        title: "Como Pesquisar Produtos com o CSSBuy Spreadsheet",
        content: "A pesquisa eficaz de produtos começa com a organização da sua busca. Ao usar o CSSBuy Spreadsheet, comece selecionando uma categoria que corresponda ao que você está procurando. Navegue pelos itens disponíveis, compare os preços entre diferentes fontes e verifique os detalhes do produto com cuidado. Procure tabelas de tamanhos, descrições de materiais e informações do vendedor. Sempre verifique o preço atual e a disponibilidade antes de prosseguir, pois as informações da planilha podem mudar ao longo do tempo.",
      },
      categories: {
        title: "Usando Categorias para Melhor Organização",
        content: "As categorias ajudam a navegar por grandes coleções de produtos de forma eficiente. Se você está procurando tênis, hoodies, jaquetas ou acessórios, começar com um filtro de categoria economiza tempo. Cada categoria no CSSBuy Spreadsheet contém itens relevantes agrupados, facilitando a comparação de produtos similares e a identificação das melhores opções para suas necessidades.",
      },
      qc: {
        title: "Fotos de QC e Controle de Qualidade",
        content: "As fotos de Controle de Qualidade (QC) são essenciais para verificar a condição do produto antes do envio. Ao pesquisar através do CSSBuy Spreadsheet, sempre verifique se há fotos de QC disponíveis para os itens que lhe interessam. Revise as imagens cuidadosamente quanto a costura, qualidade do material, precisão de cor e quaisquer defeitos visíveis. Se algo parecer diferente da descrição do produto, peça esclarecimentos antes de confirmar seu pedido.",
      },
      shipping: {
        title: "Considerações de Envio e Warehouse",
        content: "Os custos de envio dependem do peso, dimensões, destino e linha de envio. Antes de finalizar qualquer compra, estime o custo de envio usando as calculadoras disponíveis e considere opções de consolidação de warehouse. Combinar vários itens em um único envio pode reduzir os custos gerais. Sempre revise a política de armazenamento do warehouse para entender por quanto tempo os itens podem ser mantidos antes do envio.",
      },
      safety: {
        title: "Checklist de Segurança Antes de Comprar",
        content: "Antes de completar qualquer compra, verifique o link do vendedor, confira os preços atuais, confirme a disponibilidade do produto, revise as tabelas de tamanho, examine as fotos de QC, entenda as restrições de envio e confirme o custo final total incluindo envio e quaisquer taxas aplicáveis. Nunca compartilhe sua senha de conta e sempre use métodos de pagamento seguros.",
      },
      conclusion: {
        title: "Conclusão",
        content: "O CSSBuy Spreadsheet é um ponto de partida valioso para organizar a pesquisa de produtos, mas deve ser usado como uma ferramenta de referência em vez de uma garantia de qualidade ou autenticidade. Sempre verifique as informações atuais diretamente na plataforma antes de comprar. Seguindo as práticas de pesquisa e segurança descritas neste guia, você pode tomar decisões mais informadas e reduzir o risco de problemas inesperados.",
      },
    },
    cta: "Continue sua pesquisa no site principal",
  },
};